import React, { useState } from 'react';
import { Menu, Drawer, Button, Grid } from 'antd';
import { AppstoreAddOutlined, MenuOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { menuConfig } from '../utility/menuList';
import { HorizontalMenuWrapper } from './style';

const { useBreakpoint } = Grid;

const TopMenu = () => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const screens = useBreakpoint();
    const isMobile = !screens.md;

    const location = useLocation();
    const pathName = location.pathname;
    const fullPath = pathName.split('/');

    const loginDetails = useSelector((state) => state.auth.loginData);
    const exceptionApproval =
        loginDetails?.is_exception_approval ??
        loginDetails?.data?.is_exception_approval ??
        loginDetails?.data?.user_data?.is_exception_approval;
    const hasExceptionApproval =
        exceptionApproval === true ||
        exceptionApproval === 'true' ||
        exceptionApproval === 1 ||
        exceptionApproval === '1';

    const currentMenu = [
        ...(menuConfig[fullPath[2]] || []),
        ...(fullPath[2] === 'manager' && hasExceptionApproval
            ? [
                {
                    key: 'create_discount',
                    label: <Link to="/asm/manager/create_discount">Exception Discount</Link>,
                    icon: <AppstoreAddOutlined />,
                },
            ]
            : []),
    ];

    const currentPath = location.pathname.split('/').filter(Boolean).pop();

    if (!currentMenu.length) return null; // Don't render menu if there's no config

    const matchedKey = currentMenu.find(item => currentPath.startsWith(item.key))?.key || '';
    
    return (
        <HorizontalMenuWrapper>
            
                {isMobile ? (
                    <>
                        <Button icon={<MenuOutlined />} type="text" onClick={() => setDrawerVisible(true)} style={{ fontSize: 16 }} >  </Button>
                        <Drawer title="Menu" placement="left" onClose={() => setDrawerVisible(false)} open={drawerVisible} >
                            <Menu mode="vertical" selectedKeys={[matchedKey]} items={currentMenu} className="top-menu" style={{ width: '100%' }} onClick={() => setDrawerVisible(false)} />
                        </Drawer>
                    </>
                ) : (
                    <Menu mode="horizontal" selectedKeys={[matchedKey]} items={currentMenu} className="top-menu" style={{ width: '100%' }} />
                )}
            
        </HorizontalMenuWrapper>
    );
};

export default TopMenu;
